import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import {
  getDateformatMonthYearString,
  getNextMonthDate,
} from 'src/app/apv/core/utils/functions';
import { ACTIVE_SUBSCRIPTIONS_CCV, GENERIC_KEY_SUCCESS } from 'src/app/shared/common/constants';
import { IUserData } from 'src/app/shared/interfaces/user.interface';
import { GlobalStorage } from '../../core/services/globals.service';
import { BffService } from '../../core/services/http/bff.http.service';
import { JWTService } from '../../core/services/jwt/jwt.service';
import { IonicStorageService } from '../../core/services/storage/ionic/storage.service';
import { stringToRutFormatted } from '../../core/utils/formatters';
import { Util } from 'src/app/shared/common/utils/util';

@Component({
    selector: 'app-successful-regimen-modification',
    templateUrl: './successful-regimen-modification.component.html',
    styleUrls: ['./successful-regimen-modification.component.scss'],
    standalone: false,
})
export class SuccessfulRegimenModificationComponent implements OnInit,AfterViewInit{
  public finalRegimen: any = {};
  public today: any;
  public currentDate = new Date();
  public currentMonth =
    this.currentDate.getMonth() + 1 < 10
      ? `0${this.currentDate.getMonth() + 1}`
      : this.currentDate.getMonth() + 1;
  public currentDay =
    this.currentDate.getDate() < 10
      ? `0${this.currentDate.getDate()}`
      : this.currentDate.getDate();
  public currentYear = this.currentDate.getFullYear();
  public nextMonth: Date = getNextMonthDate(this.currentDate);
  public nextMonthInSpanish: string = getDateformatMonthYearString(
    this.nextMonth
  );
  public isMobile = false;
  public user!: IUserData;
  public downloadButtonLabel = 'Descargar comprobante';
  public stringToRutFormatted = stringToRutFormatted;
  public loaded = false;

  constructor(
    private readonly router: Router,
    private readonly jwtService: JWTService,
    private readonly bffService: BffService,
    private readonly ionicStorage: IonicStorageService,
    private readonly firebaseAuth: Auth,
    private readonly globalSvc: GlobalStorage,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly util: Util
  ) {
    this.isMobile = (this.document.defaultView as any).Capacitor;
  }

  ngAfterViewInit() {
    const botDiv = document.getElementById('botDiv');
    const content = document.querySelector('.success-container');
  
    if (botDiv && content) {
      content.classList.add('with-bot');
    }
  }
  async ngOnInit() {
    const token =  String(await (
      await this.firebaseAuth.currentUser
    )?.getIdToken());

    this.globalSvc.token = token;

    this.user = this.jwtService.getUserDataFromToken();
    this.today = new Date();

    const key_success_generic = await this.ionicStorage.get(
      GENERIC_KEY_SUCCESS
    );
    if (key_success_generic) {
      await this.ionicStorage.remove(GENERIC_KEY_SUCCESS);
      await this.submitNewRegimen();
    }

    if (!this.finalRegimen) this.redirectToHome();
  }
  async submitNewRegimen() {
    try {
      const dataToModifyRegimeCCV = JSON.parse(
        String(sessionStorage.getItem('DataToModifyRegimeCCV'))
      );

      const token =  String(await (
        await this.firebaseAuth.currentUser
      )?.getIdToken());

      const response = await this.bffService.modifyRegimenAccount(
        dataToModifyRegimeCCV, token
      );
      console.log('[SubmitModifyRegimen]' + '[Success] ', response);
      this.finalRegimen = {
        ...dataToModifyRegimeCCV,
        folio: response.data.data.status.status.CambioRegimen[0].folio,
        pdf: response.data.data.status.status.pdf,
      };
      await this.ionicStorage.remove(ACTIVE_SUBSCRIPTIONS_CCV);
      this.loaded = true;
      this.util.levantarEncuesta('Modificar-suscripcion-APV');
    } catch (error) {
      console.log('[SubmitModifyRegimen]' + '[Error] ', error);
    }
  }
  get isloaded() {
    return this.loaded;
  }
  private redirectToHome() {
    this.router.navigate(['/home/ccv/home']);
  }

  // format date to dd/mm/yyyy
  public formatDate(date: Date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  public downloadMyFile() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute(
      'href',
      `data:application/pdf;base64,${this.finalRegimen.pdf.content}`
    );
    link.setAttribute('download', `comprobante_modificacion.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onResize(event: any) {
    if (event.target.innerWidth < 1200) {
      this.downloadButtonLabel = 'Comprobante';
    } else {
      this.downloadButtonLabel = 'Descargar comprobante';
    }
  }

  getOtherRegimen(regimen: string): string {
    switch (regimen) {
      case 'A':
        return 'B';
      case 'B':
        return 'A';
      default:
        return '';
    }
  }
}
